import { render, staticRenderFns } from "./RectangleV1Icon.vue?vue&type=template&id=40f326cf&"
import script from "./RectangleV1Icon.vue?vue&type=script&lang=js&"
export * from "./RectangleV1Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports